import React from 'react';

/* Barres de défilement fines de la frise (WebKit). */
export default function ScrollbarStyle() {
  return (
    <style>{`
          .tl-hscroll::-webkit-scrollbar { height: 8px; }
          .tl-vscroll::-webkit-scrollbar { width: 8px; }
          .tl-hscroll::-webkit-scrollbar-track, .tl-vscroll::-webkit-scrollbar-track { background: transparent; }
          .tl-hscroll::-webkit-scrollbar-thumb, .tl-vscroll::-webkit-scrollbar-thumb { background: #DCE5E7; border-radius: 4px; }
          .tl-hscroll::-webkit-scrollbar-thumb:hover, .tl-vscroll::-webkit-scrollbar-thumb:hover { background: #B8C8CC; }
        `}</style>
  );
}
